export default __webpack_public_path__ + "static/media/wa-1715-3.fd084e00.jpg";